import { generateResourceSelectors } from '../generators/resource.selectors';

import * as types from './payment-method.types';

const resourceSelectors = generateResourceSelectors<types.IPaymentMethod>((state) => state.resource.paymentMethod);

export const paymentMethodSelectors: types.IPaymentMethodSelectors = {
  ...resourceSelectors,
};
